class ObservablePage extends HTMLElement {
  constructor() {
    super();
    this.navItem = this.querySelectorAll('nav .list-menu__item');
    this.observable = this.querySelectorAll('[data-observe] li')
    this.forSubtitles = this.querySelectorAll('[data-observe] li p strong')
    this.submenuItems = this.querySelectorAll('.stockist-list--submenu--item a');

    this.navItem.forEach( menuItem => {
      menuItem.addEventListener(
        'click',
        this.onItemClick.bind(this)
      );
    })

    this.submenuItems.forEach( item => {
      item.addEventListener(
        'click',
        this.onSubmenuItemClick.bind(this)
      );
    })
  }
  connectedCallback() {
    this.observePage()
    //this.addSubtitles();
  }
  onItemClick(e) {
    const currentTarget = e.currentTarget || e.target;
    const parentLi = currentTarget?.closest('li');
    const submenu = parentLi?.querySelector('.stockist-list--submenu');

    // On mobile, toggle submenu if it exists
    if (submenu) {
      e.preventDefault();
      // Close all other submenus
      this.navItem.forEach(item => {
        const otherParent = item.closest('li');
        const otherSubmenu = otherParent?.querySelector('.stockist-list--submenu');
        if (otherSubmenu && otherParent !== parentLi) {
          otherSubmenu.classList.remove('is-open');
        }
      });
      // Toggle current submenu
      submenu.classList.toggle('is-open');
      return;
    }

    if (!submenu) {
      const href = currentTarget?.getAttribute('href');
      if (href && href.startsWith('#')) {
        e.preventDefault();
        const targetId = href.substring(1);
        const targetContent = this.showContentById(targetId, `${targetId}-default`);
        if (targetContent) {
          setTimeout(() => {
            targetContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 50);
        }
      }
      return;
    }

    // Desktop behavior - active state
    setTimeout(()=> {
      this.navItem.forEach(item=> item.classList.remove('active'))
      e.target.classList.add('active')
    },300)
  }

  showContentById(targetId, contentId) {
    const parentContent = this.querySelectorAll('.stockist-content > li');
    const allContents = this.querySelectorAll('.stockist-content .content');
    allContents.forEach(content => content.classList.remove('is-visible'));
    parentContent.forEach((content) => content.classList.remove('is-visible'));

    const targetContent = this.querySelector(`#${contentId}`) || this.querySelector(`#${targetId}`);
    if (!targetContent) return null;

    targetContent.classList.add('is-visible');
    const parentItem = targetContent.closest('.stockist-content > li');
    if (parentItem) {
      parentItem.classList.add('is-visible');
    }

    return targetContent;
  }

  onSubmenuItemClick(e) {
    const currentTarget = e.currentTarget;
    if (!currentTarget) return;

    const href = currentTarget.getAttribute('href');
    if (!href || !href.startsWith('#')) return;

    const targetId = href.substring(1); // Remove the '#'

    const targetContent = this.showContentById(targetId, targetId);
    if (!targetContent) return;

    // Ensure visibility before scrolling to the target.
    setTimeout(() => {
      const currentSubmenu = currentTarget.closest('.stockist-list--submenu');
      if (currentSubmenu) {
        currentSubmenu.classList.remove('is-open');
      }
    }, 50);

    setTimeout(() => {
      targetContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }


  observePage() {
    window.onscroll = (()=> {
      this.observable.forEach((v,i)=> {
        let rect = v.getBoundingClientRect().y
        let offset = 100;
        if (window.innerWidth > 750 ) {
          let offset = 250;
        }
        if(rect < window.innerHeight-offset){
          this.navItem.forEach(item=> item.classList.remove('active'))
          this.navItem[i].classList.add('active')
        }
      })
    })
  }
  addSubtitles() {
    this.forSubtitles.forEach(item =>
      item
        .parentElement
        .classList
        .add('subheader')
    )
  }

}
customElements.define('observable-page', ObservablePage);